module.exports = __webpack_public_path__ + "static/media/rex.804f1ea4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/rex.jpeg
// module id = 740
// module chunks = 0